import React, {lazy} from "react";
import {ProjectSettings} from "config";
import CustomModal from "./index";
import {useTypedSelector} from "hooks/useTypedRedux";
import {selectModalRegistration} from "redux/selectors/modalSelector";
import {updateModalRegistration} from "redux/reducers/appSlice";
import {useTranslation} from "react-i18next";

const variant = ProjectSettings.variant()

const VariantRegister = lazy(() => import(`../forms/register/${variant}`))

const RegisterModal = () => {
    const {t} = useTranslation()

    const registerModal = useTypedSelector(selectModalRegistration)

    return (
        <>
            <CustomModal
                open={registerModal}
                updateOpen={updateModalRegistration}
                titleStyle={{padding: '15px 0px'}}
                styles={{borderRadius: '10px'}}
                outsideClickId={'modal-custom-date-picker'}
                title={t(`common.header.sign_up`)}
            >
                <VariantRegister />
            </CustomModal>
        </>
    )
}

export default RegisterModal;